import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ReactImageFallback from "react-image-fallback";

import Image from "../../assets/cover.jpg";
import Pin from "../../assets/pin.svg";

const ShopImageContainer = styled.div`
  width: 100%;
  height: 65%;
  background: gray;
  @media (max-width: 768px) {
    height: 56%;
  }
`;
const ShopImage = styled.img`
  width: 100%;
  height: 100%;
`;
const ShopTitle = styled.h3`
  font-size: 1.4em;
  font-weight: 500;
  margin: 0;
  padding: 10px 5%;
  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;
const ShopDescription = styled.p`
  font-size: 1.1em;
  font-weight: 400;
  margin: 0;
  padding: 0 5%;
  color: gray;
`;
const ShopLocation = styled.p`
  font-size: 0.9em;
  font-weight: 500;
  margin: 0;
  padding: 0 5%;
  color: rgb(94, 93, 93);
`;
const ShopContainer = styled(Link)`
  width: 30%;
  height: 350px;
  margin: 0 3.1% 3.1% 0;
  background: white;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #eee;
  text-decoration: none;
  color: black;

  &:hover ${ShopTitle} {
  }
  @media (max-width: 768px) {
    width: 46%;
    height: 220px;
  }
`;
const LocationImage = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 5px;
`;
const shop = (props) => {
  let location = props.shop.thanaName + " " + props.shop.cityName;
  return (
    <ShopContainer to={"/shop/" + props.shop.userName}>
      <ShopImageContainer>
        {/* {props.shop.coverImage ? (
          <ShopImage src={props.shop.coverImage} alt="shop name" />
        ) : (
          <ShopImage src={Image} alt="shop name" />
        )} */}
        <ReactImageFallback
          src={props.shop.coverImage}
          fallbackImage={Image}
          initialImage={Image}
          alt="cool image should be here"
          className="my-image"
        />
      </ShopImageContainer>
      <ShopTitle>{props.shop.name}</ShopTitle>
      {/* <ShopDescription>Note that the development build is not optimized</ShopDescription> */}
      <ShopLocation>
        <LocationImage src={Pin} />
        {/* {
          (props.shop.localAddress
            ? props.shop.localAddress
            : props.shop.thanaName,
          props.shop.cityName)
        } */}
        {/* {props.shop.thanaName} , {props.shop.cityName} */}
        {props.shop.localAddress && props.shop.localAddress !== "null"
          ? props.shop.localAddress
          : location}
      </ShopLocation>
    </ShopContainer>
  );
};

export default shop;
